import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Directive, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, switchMap } from 'rxjs/operators';
import {
  getContracts,
  getMasterDataChangeConfiguration,
  getMasterDataChangeConfigurationActionState,
  getPersonalData,
  getTicketSettings,
  LoadMasterDataChangeConfiguration,
} from '../../+state';
import { IMasterdataChangeConfiguration } from '../../models';
import { combineLatest, filter } from 'rxjs';
import { contractStatusConverter, CustomerService, masterdataHelper } from '../../services';

@UntilDestroy()
@Directive()
export class PaymentInformationBaseComponent implements OnInit {
  public sepaMandates$ = combineLatest([
    this.store.select(getPersonalData),
    this.store.select(getContracts),
  ]).pipe(
    map(([personalData, contracts]) => {
      const sepaMandates = personalData?.sepaMandates;
      if (!sepaMandates || !contracts || contracts.length === 0) {
        return sepaMandates;
      }

      const contractOrderMap = new Map(
        contracts.map((contract, index) => [contract.externalId, index])
      );

      return [...sepaMandates].sort((a, b) => {
        const aIndex = contractOrderMap.get(a.contractExternalId) ?? Number.MAX_SAFE_INTEGER;
        const bIndex = contractOrderMap.get(b.contractExternalId) ?? Number.MAX_SAFE_INTEGER;
        return aIndex - bIndex;
      });
    })
  );
  public expandAll = false;
  public masterDataChangeConfiguration: IMasterdataChangeConfiguration[] | null;
  public showChangeButton = true;

  constructor(
    protected store: Store,
    protected customerService: CustomerService
  ) {
    this.store.dispatch(LoadMasterDataChangeConfiguration());
  }

  ngOnInit() {
    this.store
      .select(getMasterDataChangeConfigurationActionState)
      .pipe(
        filter(state => state.done),
        switchMap(() =>
          combineLatest([
            this.store.select(getMasterDataChangeConfiguration),
            this.store.select(getContracts),
            this.store.select(getTicketSettings),
          ]).pipe(untilDestroyed(this))
        )
      )
      .subscribe(([masterDataChangeConfiguration, contracts, ticketSettings]) => {
        const activeContract =
          contracts?.length && contractStatusConverter.isAnyContractActive(contracts);
        const contractlessTicketCreation =
          ticketSettings?.allowContractlessTicketCreationForOtherConcerns ?? false;
        const disabledTicketManagement = this.customerService.hideTicketManagement();

        this.showChangeButton = masterdataHelper.checkShowChangeButton(
          masterDataChangeConfiguration,
          activeContract,
          contractlessTicketCreation,
          disabledTicketManagement
        );
        this.masterDataChangeConfiguration = masterDataChangeConfiguration;
      });
  }

  toggleExpandAll() {
    this.expandAll = !this.expandAll;
  }
}
